import { render, staticRenderFns } from "./TreatmentMedicinePopup.vue?vue&type=template&id=47c75d3c&scoped=true&"
import script from "./TreatmentMedicinePopup.vue?vue&type=script&lang=js&"
export * from "./TreatmentMedicinePopup.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentMedicinePopup.vue?vue&type=style&index=0&id=47c75d3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c75d3c",
  null
  
)

export default component.exports